define('LNRS/Track/TrackSearches',[
    "jquery",
    "eventManager",
    "Track/DataLayerManager",
    "Track/Events"
], function ($, eventManager, dlmanager, events) {

    // The algolia "render" event fires twice on initial page load
    var executed = false, def = $.Deferred(), promise = def.promise();

    // 7.3 Site Search Page
    return function trackSearches() {

        if (def.state() === "resolved") {
            return promise;
        }

        // 7.3.1 Onsite Search Result Page(s)
        eventManager.subscribe(events.global.algoliaRendered, function (searchProvider) {
            if (!executed) {
                executed = true;
                return;
            }

            var lastResults = searchProvider.helper.lastResults,
                numResults = lastResults.nbHits,
                o = { site_events: {} };

            if (numResults > 0) {
                o.site_events["successful_onsite_search"] = "true";
            } else {
                o.site_events["unsuccessful_onsite_search"] = "true";
            }

            if (sessionStorage.getItem("lnrs_session_autocomplete") === "true") {
                o.site_events["autocomplete_onsite_search"] = "true";
                sessionStorage.removeItem("lnrs_session_autocomplete");
            }

            o["onsite_search_term"] = lastResults.query;
            o["onsite_search_num_of_results"] = String(numResults);
            o["onsite_search_results_pagination"] = String(lastResults.page) + 1; // analytics wants 1-based index
            o["onsite_search_results_per_page"] = String(lastResults.hitsPerPage);

            dlmanager.trackAnalytics(o);
            executed = true;
            def.resolve();
        });

        // 7.3.2 Onsite Search Result Click
        eventManager.subscribe("Search-Result-selected", function (searchProvider, el) {
            var lastResults = searchProvider.helper.lastResults,
                numResults = lastResults.nbHits,
                o = {
                    site_events: { search_result_click: "true" },
                    event_name: "select search result",
                    onsite_search_term: lastResults.query,
                    onsite_search_num_of_results: String(numResults),
                    onsite_search_results_pagination: String(lastResults.page),
                    onsite_search_results_per_page: String(lastResults.hitsPerPage),
                    onsite_search_results_position: String($(el).index())
                };

            dlmanager.trackAnalytics(o);
        });

        return promise;
    };
});
